<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-truck"></i></span
    >{{ "MergeKey.Search.Title" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="block">
            <div class="p-fluid formgrid grid">
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "MergeKey.Search.MergeKey" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="mergeKeys"
                    separator=","
                    (onAdd)="chipsAdd($event, 'mergeKeys')"
                  >
                  </p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "MergeKey.Search.DoNo" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="doNos"
                    separator=","
                    (onAdd)="chipsAdd($event, 'doNos')"
                  >
                  </p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "MergeKey.Search.CreateUser" | translate }}
                </div>
                <div class="block">
                  <input
                    pInputText
                    type="text"
                    formControlName="createUser"
                    [(ngModel)]="searchParams.createUser"
                  />
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "MergeKey.Search.ConsigneeKey" | translate }}
                </div>
                <div class="block">
                  <laas-customer-dropdown
                    formControlName="consigneeKeys"
                    [showToggleAll]="false"
                    [isMultiple]="true"
                    [showLabel]="false"
                  ></laas-customer-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  #createDt
                  [title]="'MergeKey.Search.CreateDt'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event)"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "MergeKey.Search.OrderQueryScope" | translate }}
                </div>
                <div class="block mt-2">
                  <div class="formgroup-inline">
                    <div class="field-radiobutton">
                      <p-radioButton
                        formControlName="orderQueryScope"
                        [value]="OrderQueryScopeEnum.personal"
                        label="{{
                          'MergeKey.Search.PersonalOrder' | translate
                        }}"
                      ></p-radioButton>
                    </div>
                    <div class="field-radiobutton">
                      <p-radioButton
                        formControlName="orderQueryScope"
                        [value]="OrderQueryScopeEnum.all"
                        label="{{ 'MergeKey.Search.All' | translate }}"
                      ></p-radioButton>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "MergeKey.Search.ConfirmStatus" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    #consigneeKeySelect
                    formControlName="confirmStatus"
                    [filter]="false"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [options]="confirmStatusOptions"
                  >
                  </p-multiSelect>
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Search' | translate }}"
                (click)="searchClickBtn($event)"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Reset' | translate }}"
                (click)="resetClickBtn($event)"
                class="p-button-secondary ml-2"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
  </p-card>

  <div class="mt-2">
    <laas-data-table
      [selectedRows]="selectedRows"
      (selectedRowsChange)="onSelectedRowsChange($event)"
      (setPageSize)="setPageSize($event)"
      [lazy]="true"
      (rowExpanded)="searchDetailClick($event)"
      [selectable]="true"
      [dataKey]="'mergeKey'"
      (tableOnPage)="tablePageChange($event)"
      (tableOnSort)="tableSort($event)"
      [rows]="pageInfo.pageSize"
      [totalRecords]="pageInfo.totalRecords"
      [expandable]="true"
      [value]="results"
      [defaultColumns]="dataTableColumns"
      [tableKey]="preferenceKey"
    >
      <ng-template pTemplate="caption">
        <div class="flex flex-wrap column-gap-0 row-gap-2 my-1">
          <button pButton pRipple label="{{ 'MergeKey.Dialog.Header' | translate }}" icon="fa fa-object-group" iconPos="right"
            (click)="openMergeDialog($event)" class="p-button-success"></button>

          <button pButton pRipple label="{{ 'MergeKey.Button.RemoveMergeKey' | translate }}" [disabled]="selectedRows.length == 0 || hasSelectedCancelledMergeKey"
            (click)="removeMergeKeyBtn($event)" class="" ></button>

          <laas-permission-button label="{{ 'MergeKey.Button.Confirm' | translate }}" [disabled]="selectedRows.length == 0 || hasSelectedCancelledMergeKey"
            (onClick)="confirmBtn($event)" ></laas-permission-button>

          <laas-permission-button permissionCode="BtnMergeKeyCSRWithdraw" label="{{ 'MergeKey.Button.ConfirmWithdraw' | translate }}" [disabled]="selectedRows.length == 0 || hasSelectedCancelledMergeKey"
            (onClick)="confirmWithdrawBtn($event)"></laas-permission-button>

          <laas-permission-button label="{{ 'MergeKey.Button.toggleMixFacilityBtn' | translate }}" [disabled]="selectedRows.length == 0 || isMixFacilityStatusNotSame || hasSelectedCancelledMergeKey"
            (onClick)="toggleMixFacilityBtn($event)"></laas-permission-button>

          <div *ngIf="(moreActionsMenuItems[0]?.items?.length ?? 0) > 0" (mouseleave)="moreActionsMenubar.hide()" class="more-actions-wrapper">
            <p-menubar #moreActionsMenubar [model]="moreActionsMenuItems" styleClass="more-actions-menubar"></p-menubar>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'isConfirm'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping : confirmStatusOptions
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'confirmDt'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date
                      : "yyyy-MM-dd HH:mm:ss"
                      : this.laasSetting.facilityTimeZone
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date
                      : "yyyy-MM-dd HH:mm:ss"
                      : this.laasSetting.facilityTimeZone
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'bookingType'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping : bookingTypeOptions
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'isMixFacility'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping : isMixFacilityOption
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <div [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm:ss"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith : "-" }}
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
        <laas-data-table
          [tableTitle]="formatTableTitle(rowData)"
          [tableKey]="preferenceKey2"
          [dataKey]="'doNo'"
          [selectable]="true"
          [selectedRows]="selectedDoTaskRows"
          (selectedRowsChange)="selectedDoTaskRows = $event"
          [value]="rowData.details"
          [defaultColumns]="detailColumns"
          [loading]="isLoading"
          [paginator]="false"
          [style]="{ 'overflow-y': 'auto', 'overflow-x': 'auto' }"
        >
          <ng-template pTemplate="caption">
            <div class="inline-block my-1">
              <button
                pButton
                pRipple
                label="{{ 'DoMerge.Footer.Import' | translate }}"
                (click)="openImportDialog($event, rowData)"
                class="ml-4"
              ></button>
            </div>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <td *ngFor="let col of columns">
              <div [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'__delete'">
                  <span class="icon" (click)="deleteBtnClick($event, rowData)"
                    ><i class="fas fa-trash-alt"></i
                  ></span>
                </ng-container>

                <ng-container *ngSwitchCase="'doStatus'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : doStatusOptions
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'mergeStatus'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : mergeStatusOptions
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <ng-container [ngSwitch]="col.dataType">
                    <ng-container *ngSwitchCase="'date'">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd HH:mm:ss"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith : "-"
                        }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <div class="overflow-text">
                        {{ rowData[col.field] | replaceNullWith : "-" }}
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </td>
          </ng-template>
        </laas-data-table>
      </ng-template>
    </laas-data-table>
  </div>
</div>

<p-dialog
  header="{{ 'MergeKey.Dialog.Header' | translate }}"
  (onShow)="showDialog($event)"
  [(visible)]="isShowMergeDialog"
  [modal]="true"
  appendTo="body"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '80%' }"
>
  <laas-do-merge
    [doMergeType]="doMergeType"
    (importDoEvent)="importDoEvent($event)"
    (mergeDoEvent)="mergeDoEvent($event)"
  ></laas-do-merge>
</p-dialog>

<p-dialog
  header="{{ 'MergeKey.Dialog.DoMergePreview' | translate }}"
  [(visible)]="isShowMergePreviewDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '80%' }"
>
  <laas-data-table
    [selectable]="false"
    [dataKey]="'doNo'"
    [tableKey]="preferenceKey3"
    [value]="mergePreviewDos"
    [defaultColumns]="dataTableDoMergePreviewColumns"
  >
    <ng-template pTemplate="caption">
      <div class="inline-block my-1" *ngIf="disPlayIsMixFacilityCheckBox">
        <p-checkbox
          #mixFacility
          [binary]="true"
          [(ngModel)]="isMixFacility"
          label="{{ 'MergeKey.Dialog.IsMixFacility' | translate }}"
        ></p-checkbox>
      </div>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          [pSortableColumn]="col.field"
          *ngFor="let col of columns"
          pResizableColumn
          pReorderableColumn
        >
          {{ col.header | translate }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'__delete'">
            <span class="icon" (click)="doPreviewDeleteBtn($event, rowData)"
              ><i class="fas fa-trash-alt"></i
            ></span>
          </ng-container>
          <ng-container *ngSwitchCase="'doStatus'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : doStatusOptions }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'letterHeadOrgId'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : letterHeadOrgIdOptions }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'consigneeKey'">
            <div class="overflow-text">
              {{
                rowData[col.field] | optionsMapping : consigneeKeyOptionsMapping
              }}
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'taskCode'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : mergeTaskCodeOptions }}
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'assignForwarder'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : forwarderOptions }}
            </div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div [ngSwitch]="col.dataType">
              <ng-container *ngSwitchCase="'date'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
  </laas-data-table>

  <div class="mt-2 text-center">
    <button
      *ngIf="displayActionBtn('Merge')"
      pButton
      pRipple
      label="{{ 'MergeKey.Button.Merge' | translate }}"
      (click)="mergeDos($event)"
    ></button>
    <button
      *ngIf="displayActionBtn('Import')"
      pButton
      pRipple
      label="{{ 'DoMerge.Footer.Import' | translate }}"
      (click)="importDos(mergePreviewDos)"
    ></button>
  </div>
</p-dialog>

<p-dialog
  header="{{ 'Common.Dialog.Header' | translate }}"
  [(visible)]="checkMixFacilityDialog"
  [modal]="true"
  [draggable]="false"
  [baseZIndex]="1000"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '20vw' }"
>
  <div class="p-fluid formgrid mt-2">
    <div class="grid">
      <label class="col">{{
        checkMixFacilityDialogKey +
          " - " +
          ("MergeKey.Confirm.CheckMixFacility" | translate)
      }}</label>
    </div>
  </div>
  <div class="grid mt-2">
    <div class="inline-block mb-1">
      <button
        pRipple
        pButton
        label="{{ 'Common.Button.Confirm' | translate }}"
        (click)="checkMixFacilityDialogConfirmBtnClick($event)"
      ></button>
    </div>
    <div class="inline-block mb-1">
      <button
        pRipple
        pButton
        label="{{ 'Common.Button.Cancel' | translate }}"
        class="p-button-secondary"
        (click)="checkMixFacilityDialogCancelBtnClick($event)"
      ></button>
    </div>
  </div>
</p-dialog>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
